import axios from 'axios';
import { useApi } from '@dreamtree-org/twreact-ui';
import apiMap from '@api';
import { isFixtureUrl, fixtureAdapter } from '@/lib/fixtures';
import '@/fixtures';

/**
 * App-configured wrapper around twreact-ui's useApi. Same-origin (Vite proxies
 * /api to the backend); withCredentials so the httpOnly JWT cookie is sent.
 * Registry entries that point at /__fixtures/* are served locally (lib/fixtures.js)
 * until their backend exists. Returns { data, error, loading, fetchApi, fetchData }.
 */
function createRequestInstance() {
  const instance = axios.create({ withCredentials: true });
  const network = axios.getAdapter(axios.defaults.adapter);
  instance.defaults.adapter = (config) => (isFixtureUrl(config.url) ? fixtureAdapter(config) : network(config));
  return instance;
}

export function useAppApi() {
  return useApi({ apiMap, createRequestInstance });
}
